import { auth } from "./firebase";
import { getTelegramInitData } from "../utils/telegramUtils";

const DEFAULT_STORE_WORKER_BASE_URL = "https://psh-store-worker.neelamdevisahni521.workers.dev";
const STORE_WORKER_BASE_URL = (
  process.env.REACT_APP_STORE_WORKER_BASE_URL ||
  process.env.REACT_APP_STORE_WORKER_URL ||
  process.env.REACT_APP_WORKER_BASE_URL ||
  DEFAULT_STORE_WORKER_BASE_URL
).replace(/\/+$/, "");

const TELEGRAM_LINK_ENDPOINT = `${STORE_WORKER_BASE_URL}/api/v1/telegram/link`;
const TELEGRAM_STATUS_ENDPOINT = `${STORE_WORKER_BASE_URL}/api/v1/telegram/bind/status`;
const TELEGRAM_MINIAPP_BIND_ENDPOINT = `${STORE_WORKER_BASE_URL}/api/v1/telegram/bind/miniapp`;
const TELEGRAM_UNBIND_ENDPOINT = `${STORE_WORKER_BASE_URL}/api/v1/telegram/unbind`;

const getAuthToken = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error("User session missing");
  return user.getIdToken();
};

const parseWorkerResponse = async (response, fallbackError) => {
  const rawText = await response.text();
  let data = null;
  try {
    data = rawText ? JSON.parse(rawText) : null;
  } catch {
    data = null;
  }

  if (!response.ok || data?.success === false) {
    const fromJson = String(data?.error || "").trim();
    const fromText = String(rawText || "").trim();
    throw new Error(fromJson || fromText || fallbackError || `Request failed (HTTP ${response.status})`);
  }

  return data;
};

export const fetchTelegramBindLink = async () => {
  const token = await getAuthToken();
  const response = await fetch(TELEGRAM_LINK_ENDPOINT, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return parseWorkerResponse(response, `Failed to get bind link (HTTP ${response.status})`);
};

export const fetchTelegramBindStatus = async () => {
  const token = await getAuthToken();
  const response = await fetch(TELEGRAM_STATUS_ENDPOINT, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return parseWorkerResponse(response, "Failed to get bind status");
};

export const bindTelegramMiniApp = async () => {
  const initData = getTelegramInitData();
  if (!initData) {
    throw new Error("Open the store inside Telegram to bind automatically.");
  }

  const token = await getAuthToken();
  const response = await fetch(TELEGRAM_MINIAPP_BIND_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ initData })
  });

  return parseWorkerResponse(response, "Failed to bind Telegram automatically");
};

export const unbindTelegramAccount = async () => {
  const token = await getAuthToken();
  const response = await fetch(TELEGRAM_UNBIND_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({})
  });

  return parseWorkerResponse(response, "Failed to unlink Telegram account");
};

const TELEGRAM_DIRECT_BIND_ENDPOINT = `${STORE_WORKER_BASE_URL}/api/v1/telegram/bind`;

export const bindTelegramAccountDirect = async ({ chatId, username = "" } = {}) => {
  const token = await getAuthToken();
  const response = await fetch(TELEGRAM_DIRECT_BIND_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ chatId, username })
  });

  return parseWorkerResponse(response, "Failed to bind Telegram account");
};
